import { Box } from '@mui/material'
import React, { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import { useFeatureFlag } from '../../../utils/hooks/useFeatureFlag'
import { Styles } from '../../../types'

const styles: Styles = {
  fieldset: {
    marginTop: '2rem',
  },
  fieldsetRedesign: {
    height: '100%',
    marginTop: '2rem',
    overflow: 'auto',
    flexGrow: 1,
  },
  legend: (theme) => ({
    marginTop: '1rem',
    marginBottom: '0.75rem',
    fontSize: '1.125rem',
    lineHeight: 1.2,
    [theme.breakpoints.up('tablet')]: {
      marginTop: '2rem',
    },
  }),
  interestName: {
    fontFamily: 'Prelo-Bold, sans-serif',
  },
  interestsList: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    alignItems: 'flex-start',
    overflow: 'auto',
    margin: '-0.125rem 0 -0.375rem',
  },
  redesignInterestsList: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    alignItems: 'flex-start',
    overflow: 'hidden',
  },
}

interface InterestSelectorFieldsetProps {
  children: ReactNode
  interestText: string
  testId: string
}

const InterestSelectorFieldset = ({
  children,
  interestText,
  testId,
}: InterestSelectorFieldsetProps) => {
  const { t } = useTranslation()
  const userRedesignFeatureEnabled = useFeatureFlag('UserProfile_Redesign')

  return (
    <Box
      component="fieldset"
      sx={
        userRedesignFeatureEnabled ? styles.fieldsetRedesign : styles.fieldset
      }
      data-testid={`Div_ProfileInterestsContainer_${testId}`}>
      <Box
        component="legend"
        sx={styles.legend}
        data-testid={`Lbl_ProfileInterestsCategoryHeader_${testId}`}>
        {t('UserProfile.ProfileWizard.SelectThe')}{' '}
        <Box
          data-testid={`Lbl_ProfileInterestsCategoryHeaderType_${testId}`}
          component="strong"
          sx={styles.interestName}>
          {t(interestText)}
        </Box>{' '}
        {t('UserProfile.ProfileWizard.YouAreInterestedIn')}
      </Box>
      <Box
        component="ul"
        sx={
          userRedesignFeatureEnabled
            ? styles.redesignInterestsList
            : styles.interestsList
        }
        data-testid={`Div_ProfileInterestsCategories_${testId}`}>
        {children}
      </Box>
    </Box>
  )
}

export default InterestSelectorFieldset
